import React, { Component } from 'react';
import { connect } from 'react-redux';
import throttle from 'lodash.throttle';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import trans from 'counterpart';
// import styled from 'styled-components';
import NavContext from '../contexts/NavContext';
import { getCurrentContent } from '../selectors/contentSelectors';
import { APP_DIERENBOS, APP_BEEKSEBERGEN } from '../constants/apps';
import { getMediaUrl } from '../utilities/mediaUtilities';

// const NavbarBackground = styled.div`
//   background-color: #fff;
//   height: 91px;
//   width: 100%;
//   position: absolute;
//   top: 47px;

//   @media (max-width: 991px) {
//     display: none;
//   }
// `;

class NavBarBlock extends Component {
  state = {
    activeLink: null,
    collapse: false,
    menuCollapse: false,
    showLangDropdown: false,
    search: '',
    stickyNav: false,
  }

  constructor(props) {
    super(props);
    this.searchInputRef = null;
    this.throttled = throttle(this.scrollEventHandler, 150, { leading: true });
  }

  componentDidMount = () => {
    if (!this.props.isOnAccommodationPage) {
      window.addEventListener('scroll', this.throttled);
    }
  };

  componentDidUpdate(prevProps) {
    if (this.state.collapse) {
      this.searchInputRef.focus();
    }
    if (prevProps.isOnAccommodationPage && !this.props.isOnAccommodationPage) {
      window.addEventListener('scroll', this.throttled);
    }
    if (!prevProps.isOnAccommodationPage && this.props.isOnAccommodationPage) {
      window.removeEventListener('scroll', this.throttled);
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.throttled);
  }

  setActiveLink = id => this.setState({ activeLink: id });

  scrollEventHandler = () => {
    const { stickyNav } = this.state;
    if (stickyNav && window.pageYOffset < 50) {
      this.setState({ stickyNav: false });
    }
    if (!stickyNav && window.pageYOffset >= 50) {
      this.setState({ stickyNav: true });
    }
  };

  /**
   * Handle search input field value
   */
  handleSearchChange = evt => this.setState({ search: evt.target.value });

  /**
   * Display / hide optional languages
   */
  toggleLanguageDropdown = () => this.setState(prevState => ({
    showLangDropdown: !prevState.showLangDropdown
  }));

  /**
   * Display / hide search input field
   */
  toggleCollapse = () => this.setState(prevState => ({
    collapse: !prevState.collapse,
    search: prevState.collapse ? prevState.search : ''
  }));

  /**
   * Don't send the form in case no search query is given
   * @param {*} event
   */
  handleSearch = (event) => {
    this.setState({ showLangDropdown: false });
    if (this.state.search === '') {
      event.preventDefault();
    }
  }

  /**
   * Display / hide menu for mobile view toggling hamburger
   */
  toggleMenu = () => this.setState(prevState => ({ menuCollapse: !prevState.menuCollapse }));

  /**
   * Checks if the passed slug is part of the current page' path
   */
  isActive = (slug) => {
    if (this.props.currentPath.startsWith(slug)) {
      return true;
    }
    return false;
  }

  render = () => {
    const { currentContent, placeholder, manageTags } = this.props;
    const { menuCollapse, stickyNav } = this.state;

    if (!currentContent) {
      return null;
    }

    return (
      <nav className={`navbar navbar-toggleable-md main-navigation ${stickyNav ? 'no-sub affix' : 'has-sub affix-top'} ${menuCollapse ? 'collapse' : ''}`} {...manageTags}>
        {stickyNav === false && process.env.RAZZLE_APP === 'dierenbos' && (
          <div className="navbar-background" />
        )}
        <div className="container">
          <div className="navbar-header">
            <button
              className={`navbar-toggler navbar-toggler-right ${menuCollapse ? '' : 'collapsed'}`}
              type="button"
              onClick={this.toggleMenu}
              data-toggle="collapse"
              data-target="#navbar-dropdown-3692"
              aria-controls="navbar-dropdown-3692"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <strong className="list-inline-item align-middle text-white">Menu</strong>
              <div className="list-inline-item align-middle mr-0">
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </div>
            </button>
            <Link to={trans('routes.home')} className="navbar-brand">
              <img
                src={getMediaUrl('/img/logo.svg')}
                width="135"
                className="navbar-brand-image"
                alt={process.env.RAZZLE_APP === APP_DIERENBOS ? 'Dierenbos' : 'Beekse Bergen'}
                title={process.env.RAZZLE_APP === APP_DIERENBOS ? 'Dierenbos' : 'Beekse Bergen'}
              />
            </Link>
          </div>

          <div id="navbar-dropdown-3692" className={`navbar-collapse ${this.state.menuCollapse ? '' : 'collapse'}`}>
            <div className="navbar-container">
              <div className="navbar-top">
                <div className="container">
                  <ul className="nav navbar-nav">
                    {placeholder(0)}
                  </ul>
                  <div className="nav navbar-right">
                    <div className={`dropdown language-dropdown ${this.state.showLangDropdown ? 'show' : ''}`}>
                      <button className="btn btn-lang dropup" type="button" id="language" onClick={this.toggleLanguageDropdown}>
                        <span className={`lang lang-${this.props.language}`}><i className="material-icons md-18">arrow_drop_down</i></span>
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <Link
                            to={(currentContent.translation_group && currentContent.translation_group.nl) || '/'}
                            className={`lang lang-nl ${this.props.language === 'nl' ? 'hidden-xs-up' : ''}`}
                            hrefLang="nl-nl"
                            rel="alternate"
                          >
                            &nbsp;
                          </Link>
                        </li>
                        {process.env.RAZZLE_APP === APP_BEEKSEBERGEN && (
                          <>
                            <li>
                              <Link
                                to={(currentContent.translation_group && currentContent.translation_group.en) || '/en'}
                                className={`lang lang-en ${this.props.language === 'en' ? 'hidden-xs-up' : ''}`}
                                hrefLang="en-gb"
                                rel="alternate"
                              >
                                &nbsp;
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={(currentContent.translation_group && currentContent.translation_group.fr) || '/fr'}
                                className={`lang lang-fr ${this.props.language === 'fr' ? 'hidden-xs-up' : ''}`}
                                hrefLang="fr-fr"
                                rel="alternate"
                              >
                                &nbsp;
                              </Link>
                            </li>
                          </>
                        )}
                        <li>
                          <Link
                            to={(currentContent.translation_group && currentContent.translation_group.de) || '/de'}
                            className={`lang lang-de ${this.props.language === 'de' ? 'hidden-xs-up' : ''}`}
                            hrefLang="de-de"
                            rel="alternate"
                          >
                            &nbsp;
                          </Link>
                        </li>
                      </ul>
                    </div>

                    <form className="navbar-form pull-right" method="get" action={trans('routes.search')} onSubmit={this.handleSearch}>
                      <div className={`form-group ${this.state.collapse ? 'set-width' : ''} `}>
                        <input
                          type="text"
                          id="search"
                          name="search"
                          className="form-control"
                          placeholder={trans('form.placeholder.search')}
                          autoComplete="off"
                          value={this.state.search}
                          onChange={this.handleSearchChange}
                          ref={(searchInput) => { this.searchInputRef = searchInput; }}
                        />
                      </div>
                      <button type="submit" className="btn btn-default" onClick={this.toggleCollapse}>
                        <i className="material-icons">&#xE8B6;</i>
                      </button>
                    </form>

                  </div>
                </div>
              </div>
              <div className="navbar-main">
                <NavContext.Provider value={{ active: this.state.activeLink, setActive: this.setActiveLink, mobileMenuIsOpen: this.state.menuCollapse }}>
                  <ul className="nav navbar-nav">
                    {placeholder(1)}
                  </ul>
                </NavContext.Provider>
                {process.env.RAZZLE_APP === APP_BEEKSEBERGEN && (
                  <ul className="nav navbar-nav navbar-right navbar-cta">
                    <li>
                      <Link to={trans('routes.tickets')} className="btn btn-primary-color btn-tickets">Tickets</Link>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

NavBarBlock.propTypes = {
  currentContent: PropTypes.object,
  currentPath: PropTypes.string,
  language: PropTypes.string,
  placeholder: PropTypes.func.isRequired,
  isOnAccommodationPage: PropTypes.bool,
};

const getAccommodationsRoute = () => {
  if (process.env.RAZZLE_APP === 'dierenbos') {
    return trans('routes.accommodations_dierenbos');
  }

  return trans('routes.accommodations');
};

const mapState = (state, ownProps) => ({
  currentContent: getCurrentContent(state),
  language: state.preferences.locale,
  isOnAccommodationPage: ownProps.location.pathname.indexOf(getAccommodationsRoute()) > -1,
});

export default withRouter(connect(mapState)(NavBarBlock));
